import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { VTextField } from 'vuetify/lib/components'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKInput',
  props: {
    autocomplete: { default: 'off' },
    value: null,
    label: { default: '' },
    prefix: { default: '' },
    error: { type: Boolean, default: false },
    errorMessages: { default: () => [] },
    placeholder: { default: '' },
    type: { default: 'text' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { default: () => [] },
    appendIcon: { default: undefined },
    prependIcon: { default: '' },
    appendOuterIcon: { default: '' },
    hideDetails: { type: [Boolean, String], default: 'auto' },
    autofocus: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    color: { default: 'var(--color-blue-800)' },
    min: { default: 0 },
    max: { default: '' }
  },
  emits: ["blur", "focus", "input", "keyup", "click:append", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'blur'): void
  (e: 'focus'): void
  (e: 'input', value: string | number): void
  (e: 'keyup', value: KeyboardEvent): void
  (e: 'click:append'): void
  (e: 'update:modelValue', value: string | number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { autocomplete: string, value: InstanceType<typeof VTextField>['$props']['value'], label: string, prefix: string, error: boolean, errorMessages: string | string[], placeholder: string, type: string, readonly: boolean, required: boolean, rules: ((value: string | number | undefined) => unknown)[], appendIcon: string | (string | [string, number])[] | (new () => unknown), prependIcon: string | (string | [string, number])[] | (new () => unknown), appendOuterIcon: string | (string | [string, number])[] | (new () => unknown), hideDetails: boolean | 'auto', autofocus: boolean, dense: boolean, disabled: boolean, color: string, min: number, max: number | string };





const inputValue = ref<string | number>(props.value)
watch(
  () => props.value,
  () => {
    inputValue.value = props.value
  }
)
watch(
  () => inputValue.value,
  () => {
    if (props.type === 'number') {
      emit('update:modelValue', inputValue.value ? parseInt(inputValue.value as string, 10) : '')
      return
    }

    emit('update:modelValue', inputValue.value)
  }
)

return { __sfc: true,emit, props, inputValue, VTextField }
}

})